import React from 'react';
import PropTypes from 'prop-types';
// common components
import FormField from './../../../common/Forms/FormField/FormField';

const ManageTrainer = ({ onDelete, trainerDetails, onChange, isEdit }) => {
	if (onDelete) {
		return (
			<div className='ManageTrainer'>
				<div>Are you sure, you want to delete?</div>
			</div>
		);
	};

	return (
		<div className='ManageTrainer'>
			<div className="half">
				<div>
					<FormField
						label="first name"
						name="firstname"
						type="text"
						placeholder="enter firstname"
						value={trainerDetails.firstname.trimStart()}
						onChange={onChange}
						validate={['required']}
						autoFocus
                        maxLength={50}
					/>
				</div>
				<div>
					<FormField
						label="last name"
						name="lastname"
						type="text"
						placeholder="enter lastname"
						value={trainerDetails.lastname.trimStart()}
						onChange={onChange}
						validate={['required']}
                        maxLength={50}
					/>
				</div>
			</div>
			<div className="half">
				<div>
					<FormField
						label="e-mail"
						name="email"
						type="email"
						placeholder="enter email"
						value={trainerDetails.email}
						onChange={onChange}
						validate={['required', 'email']}
                        maxLength={50}
                        disabled={isEdit}
					/>
				</div>
				<div>
					<FormField
						label="phone"
						name="phone"
						type="number"
						placeholder="enter phone number"
						value={trainerDetails.phone}
						onChange={onChange}
						maxLength={10}
						validate={['rangeLength10']}
					/>
				</div>
			</div>
			<div className="half">
				<div>
					<FormField
						label="country"
						name="country"
						type="text"
						placeholder="enter country name"
						value={trainerDetails.country.trimStart()}
						onChange={onChange}
                        maxLength={50}
					/>
				</div>
				<div>
					<FormField
						label="city"
						name="city"
						type="text"
						placeholder="enter city name"
						value={trainerDetails.city.trimStart()}
						onChange={onChange}
                        maxLength={50}
					/>
				</div>
			</div>
		</div>
	);
}

ManageTrainer.propTypes = {
	
};

ManageTrainer.defaultProps = {
	
};

export default ManageTrainer;



// WEBPACK FOOTER //
// ./components/Trainer/ManageTrainer/ManageTrainer.js